<template>
  <div>
    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <br/>
     <v-row dense justify="center" v-if="livesession_id!=null && livesession_id!=''">
       <v-col cols="12" sm="3" md="3">
        <v-icon color="error"></v-icon>
                        <v-file-input
                            v-model="attachments"
                            placeholder="Upload Document if any"
                            label="Document"
                            prepend-icon="mdi-paperclip"
                            >
                            <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">{{ text }}</v-chip>
                            </template>
                     </v-file-input> 
       </v-col> 
       <v-col cols="12" sm="2" md="2">
        <br>
         <v-btn class="button" @click="saveDoc" :loading="loader">Upload</v-btn>
       </v-col>
        <v-col cols="12" sm="3" md="3">

          <template v-if="livesession_doc!=null">
                <h3>View Uploaded Document File</h3>
                <a class="p-2" :href="aws_path + livesession_doc" target="blank">
                      <v-tooltip top>
                        <template v-slot:activator="{ attrs }">
                          <v-btn icon v-if="livesession_doc != null" v-bind="attrs">
                            <v-icon color="black">mdi-eye</v-icon></v-btn
                          >
                        </template>
                        <span> View Uploaded Document File!!! </span>
                      </v-tooltip>
                    </a>
              </template>
        </v-col>
     </v-row>

      <v-row dense justify="center" v-if="extention!=null">
        <span v-if="extention == 'jpeg' || 'jpg' || 'png' ">
          <v-col cols="12" sm="4" md="4" v-if="livesession_doc!=null">
            <img :src="aws_path + livesession_doc" style="border: 3px solid black;"  class="bg-white"
            width="200"
            :aspect-ratio="1" />
             </v-col>
          </span>
          <v-col cols="12" sm="2" md="2">
        <br>
        </v-col>
        <v-col cols="12" sm="8" md="8">
        <span v-if="extention=='pdf'">
            <!-- <template v-if="pdf_viewer_flag" >
              <v-btn
              color="red"
              small
              title="Close the pdf viewer"
              @click="pdf_viewer_flag = false"
            >
              <v-icon>mdi-close</v-icon>
          </v-btn><span style="opacity:0.5"> It may take time to load file</span> -->
            <PDFJSViewer :path="`${pdf_link}`" :fileName="`${pdf_name}`"/>
            <!-- </template> -->
        </span>
          <span v-if="doc_viewer_flag">
            <!-- <template v-if="doc_viewer_flag" >
              <v-btn
                color="red"
                small
                title="Close the document viewer"
                @click="doc_viewer_flag = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn><span style="opacity:0.5"> It may take time to load file</span> -->
          
                <doc-viewer 
                  :selected_file="selected_file"
                ></doc-viewer>
                <!-- </template> -->
          </span>

       </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import DocViewer from "@/components/Document/DocViewer";
import PDFJSViewer from '@/components/Document/PDFJSViewer'
export default {
    components: {
       "doc-viewer": DocViewer,
        PDFJSViewer
  },
  props: ["sel_crs"],
  data: () => ({
    attachments:null,
    selected_file: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    meeting_code: null,
    show_screen: false,
    name: "vikas",aws_path:"",livesession_id:"",livesession_doc:"",loader:false,extention:"",pdf_viewer_flag:false,pdf_name:"",pdf_link:"",
     doc_viewer_flag: false,

  }),
  methods: {
    saveDoc(){
            let formData = new FormData();
            formData.append("id", this.livesession_id);
            formData.append("attachment", this.attachments);
            this.loader = true
        axios 
            .post("/LiveClass/saveLiveSessionDoc", formData)
            .then((res) => {
            if (res.data.flag == "YES") {
                this.loader = false;
                this.showSnackbar("#4caf50", "Save successfully");
                this.attachments=null
                this.livesession_doc=res.data.livesession_doc
                this.call();
            }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.loader = false;
            })
            .finally(() => {
                this.loader = false;
            });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////
    async call() {
      this.overlay = true;
      const formdata = {
        sel_crs: this.sel_crs,
      };
      try {
        const res = await axios.post("/liveClass/getLiveSessionDocument", formdata);
        if (res.data.flag == "YES") {
          this.meeting_code = res.data.meeting_code;
          this.livesession_id=res.data.livesession_id
          this.livesession_doc=res.data.livesession_doc
          this.extention=res.data.extension

          var office = ["pptx","docx","xlsx","ppt","doc","xls"]
          var type = "text"
          this.doc_viewer_flag = false;
          this.pdf_viewer_flag = false;
          this.pdf_link = "";

             if(this.extention == "pdf"){
                this.pdf_link = this.aws_path + this.livesession_doc
                this.pdf_name = 'Doc'
                this.pdf_viewer_flag = true;
             }
             if(office.indexOf(this.extention) > -1){
                  this.doc_viewer_flag = true;
                  type = "office"
                  this.selected_file = {docValue: this.aws_path +this.livesession_doc,
                  docType:type};
              }
        }else if (res.data.flag == "No") {
          this.showSnackbar("red", res.data.snackbar);
          this.meeting_code = res.data.meeting_code;
          this.livesession_id=res.data.livesession_id
          this.livesession_doc=res.data.livesession_doc
          this.extention=res.data.extension
           var office = ["pptx","docx","xlsx","ppt","doc","xls"]
          var type = "text"
          this.doc_viewer_flag = false;
          this.pdf_viewer_flag = false;
          this.pdf_link = "";

          if(this.extention == "pdf"){
            this.pdf_link = this.aws_path + this.livesession_doc
            this.pdf_name = 'Doc'
            this.pdf_viewer_flag = true;
          }
          if(office.indexOf(this.extention) > -1){
              this.doc_viewer_flag = true;
              type = "office"
              this.selected_file = {docValue: this.aws_path +this.livesession_doc,
              docType:type};
          }
        }
        else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.overlay = false;
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
        this.overlay = false;
      } finally {
        console.log("bye...");
        this.overlay = false;
      }
    },
  },
  mounted() {
    console.log("sel_crs", this.sel_crs);
    this.call();
  },
   created() {
    this.aws_path = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
.meeting-code {
  color: #3f51b5;
  font-size: 21px;
  font-weight: 500;
}
</style>